import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, AppThunk } from "../../../store";
import { accountState } from "./accountTypes";
import {
  getRestAllAccountNameWithAxNumber,
} from "../../../api/accountStore";
import { AccountNameWithAxNumber, AccountSearchQuery } from "lib/ShiOneClient";
import GlobalConstants from "@constants";

const initialState: accountState = {
  allAccountNamesWithAxNumberStatus: "idle",
  allAccountNamesWithAxNumbers: [] as AccountNameWithAxNumber[],
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    receivingAllAccountNamesWithAxNumbers(state) {
      state.allAccountNamesWithAxNumberStatus =
        GlobalConstants.fetchStatus.loading;
    },
    receivedAllAccountNamesWithAxNumbers(
      state,
      action: PayloadAction<AccountNameWithAxNumber[]>
    ) {
      state.allAccountNamesWithAxNumbers = action.payload;
      state.allAccountNamesWithAxNumberStatus =
        GlobalConstants.fetchStatus.complete;
    },
    receiveAllAccountNamesWithAxNumbersError(state) {
      state.allAccountNamesWithAxNumberStatus =
        GlobalConstants.fetchStatus.error;
    },
  },
});

export const getAllAccountNamesAndAxNumbers =
  (searchQuery: AccountSearchQuery): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(accountSlice.actions.receivingAllAccountNamesWithAxNumbers());
    try {
      const accountNamesWithAxNumbers = await getRestAllAccountNameWithAxNumber(
        searchQuery
      );
      dispatch(
        accountSlice.actions.receivedAllAccountNamesWithAxNumbers(
          accountNamesWithAxNumbers
        )
      );
    } catch (err) {
      dispatch(accountSlice.actions.receiveAllAccountNamesWithAxNumbersError());
    }
  };

export default accountSlice.reducer;
